import { createI18n } from 'vue-i18n'
import tr from './locales/tr.json'
import en from './locales/en.json'

export const SupportedLocales = ['tr', 'en'] as const
export type SupportedLocale = (typeof SupportedLocales)[number]
export const DefaultLocale: SupportedLocale = 'en'

export type MessageSchema = typeof en

function isSupported(v: string): v is SupportedLocale {
  return (SupportedLocales as readonly string[]).includes(v)
}

function getInitialLocale(): SupportedLocale {
  const stored = localStorage.getItem('locale')
  if (stored && isSupported(stored)) return stored
  const browser = navigator.language.split('-')[0] ?? ''
  if (isSupported(browser)) return browser
  return DefaultLocale
}

export const i18n = createI18n<[MessageSchema], SupportedLocale>({
  legacy: false,
  locale: getInitialLocale(),
  fallbackLocale: 'en',
  messages: { tr, en },
})
